import React from 'react'
import Loader from '../../Constant/Loader'
import AdminAppBar from '../../adminComponents/AdminAppBar'
import { ToastContainer } from 'react-toastify'
import BackArrows from '../../Form/BackArrow/BackArrows'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { getIcons } from '../../Constant/Constant'
import ConfirmationModal from '../../shareableContainer/ConfirmationModal'

const ImageUploaderTemplate = () => {
  const [loading, setLoading] = useState(false);
      const navigate = useNavigate();
      const icons = getIcons();
    
      const handleBack = () => {
        navigate(-1);
      };
      const handleAddTemplate = () => {
      }
  return (
    <div className="bg-appGrayBackground pb-10 pt-14">
    {loading && <Loader />}
     <AdminAppBar />
    <ToastContainer />
    <div className="mt-14 px-20 xl:px-6 relative flex justify-between gap-5">
      <div className="flex gap-6">
        <BackArrows onClick={handleBack} />
        <div>
          <h1 className="text-4xl font-semibold whitespace-nowrap">
            New Image
          </h1>
        </div>
      </div>
      <div>
        <button
          onClick={handleAddTemplate}
          className="border-2 whitespace-nowrap bg-customGreen rounded-md font-semibold p-1 px-5 w-fit text-lg text-white h-10 text-center"
        >
          Add Template
        </button>
      </div>
    </div>
      

      <div className="mx-20 mt-5 bg-white rounded-lg shadow-md">
        <div className="flex flex-col gap-5 px-20 pt-2 pb-12">
        <div className="flex  gap-5 items-center mt-12">
            <div className="">
              <h2 className="text-3xl font-medium text-gray-900">
              Content Group : 
              </h2>
            </div>
            <div>
              <h2 className="text-2xl ml-12 font-bold text-gray-900">
              Festiva Wish
              </h2>
            </div>
          </div>

          <div className="flex gap-5 items-center mt-10">
            <div className="w-1/3">
              <h2 className="text-3xl font-medium text-gray-900 whitespace-nowrap">
              Image Title
              </h2>
            </div>
            <div className="flex flex-col w-full ">
              <input
                type="text"
                placeholder="Image Title"
                className="px-3 border-2 bg-stone-100 border-stone-200 rounded-xl w-full h-10"
              />
           
            </div>
          </div>


          <div className="flex gap-5 items-center">
            <div className="w-1/3">
              <h2 className="text-3xl font-medium text-gray-900 whitespace-nowrap">
              Attach Images
              </h2>
            </div>
            <div className="flex flex-col w-full mt-10">
              <div className="relative w-full">
                <label className="flex items-center gap-2 px-3 border-2 bg-stone-100 border-stone-200 rounded-xl w-full h-10 cursor-pointer">
                  <img
                    src={icons?.uploadIcon}
                    className="w-5 h-5"
                    alt="Upload"
                  />
                  <span className="text-gray-600">Upload Images form your device</span>
                  <input
                    type="file"
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    //onChange={handleFileUpload}
                  />
                </label>
              </div>

              <p className="text-sm mt-3">
                * Note only 1 image can upload jpeg and png will be accepted
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageUploaderTemplate